import { render } from "./IconPropsCmp.vue?vue&type=template&id=9174ab6e"
import script from "./IconPropsCmp.vue?vue&type=script&lang=js"
export * from "./IconPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__